import { NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'app-qc-profile-checkbox',
  templateUrl: './qc-profile-checkbox.component.html',
  styleUrls: ['./qc-profile-checkbox.component.less'],
  viewProviders: [{provide: ControlContainer, useExisting: FormGroupDirective}],
  imports: [ReactiveFormsModule, NgIf]
})
export class QcProfileCheckboxComponent implements OnInit {

  @Input() name: string;
  @Input() label: string;
  @Input() code: string;
  @Input() stared: boolean = true;

  constructor() { }

  ngOnInit() {
  }

}
